import store_compte from '@/store/mods/caisse/compte.js'

export default {
    name: 'manage-banque',
    components: {},
    props: {
        toggler: Number,
        selected_banque: {
            type: Object,
            default: () => {}
        },
        is_edit: Number
    },
    data() {
        return {
            banque_data: {
                banque_id: 0,
                banque_data_type: '',
                libelle: "",
                compte: "",
            },
            save_loading: false,
            msg_err: "",
        }
    },

    watch: {
        toggler() {
            this.banque_data = {
                banque_id: 0,
                banque_data_type: '',
                libelle: "",
                compte: "",
            }
            this.$refs.banque_form.reset()

            if (this.is_edit == 1) {
                this.autoFillFields()
            }
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        autoFillFields() {
            this.banque_data = {
                banque_id: this.selected_banque.id,
                banque_data_type: 'banque',
                libelle: this.selected_banque.libelle,
                compte: this.selected_banque.numero_compte,
            }
        },

        async save() {
            const isValid = await this.$refs.banque_form.validate();
            if (!isValid) {
                return;
            }

            this.banque_data.data_type = 'banque'

            this.save_loading = true
            store_compte.addCompteOperation(this.banque_data).then((response) => {
                if (response.success) {
                    this.$refs.mng_banque.click()
                    this.successToast(response.message)

                    this.$refs.banque_form.reset()
                    this.$emit("emitRefreshBanque")
                } else {
                    this.msg_err = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_err = "Une erreur est survenue lors de l'enregistrement de la banque. Veuillez réessayer plus tard."
            })
        }
    }
}